export default "__VITE_ASSET__08bdcda4__"